import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { defineMessages } from 'react-intl';
import * as actions from '../../../../state';

const controlsList = [{
  name: 'fontSize',
  labelId: 'FONT_SIZE',
  type: 'slider',
  default: 35,
  options: {
    min: 6,
    max: 200,
    step: 1,
  },
}];

const percentageControlsList = [{
  name: 'decimalPlaces',
  labelId: 'DECIMAL_PLACES',
  type: 'slider',
  default: 0,
  options: {
    min: 0,
    max: 2,
    step: 1,
  },
}];

const messages = defineMessages({
  SINGLE_STAT: {
    id: 'SINGLE_STAT',
    defaultMessage: 'Single Stat',
  },
  FONT_SIZE: {
    id: 'FONT_SIZE',
    defaultMessage: 'Font Size',
  },
  DECIMAL_PLACES: {
    id: 'DECIMAL_PLACES',
    defaultMessage: 'Decimal Places',
  },
});

function StatBlockStyleControls({ renderControlGroup }) {
  const selectedChart = useSelector(actions.readStateSelectedChart);
  const chartsManifest = useSelector(actions.readChartsManifest);

  let finalControlList = controlsList;

  if (selectedChart.data_sources.length) {
    const source = selectedChart.data_sources[0];
    const dataOption = chartsManifest[selectedChart.type].dataOptions[source.stat];
    const dataUnit = dataOption ? dataOption.unit : null;

    if (dataUnit === 'percent') finalControlList = [...controlsList, ...percentageControlsList];
  }

  // controls by group, used to present controls in like groups
  const controlsGroups = [{
    labelId: 'SINGLE_STAT',
    controls: finalControlList,
  }];

  return controlsGroups.map(
    (controlsGroup, cgIndex) => renderControlGroup(controlsGroup, messages, cgIndex),
  );
}

StatBlockStyleControls.propTypes = {
  renderControlGroup: PropTypes.func.isRequired,
};

export default StatBlockStyleControls;
